import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MagnifyImage } from '../../../CommonComponents/MagnifyImage';
import { RxCross1 } from "react-icons/rx";


function OrderDetail() {

  const id = useLocation();
  const objectId = id && id.state;

  const BASE_URL = process.env.REACT_APP_PP_URL;
  const token = sessionStorage.getItem('tokenKey');

  const [info, setInfo] = useState();
  const detail = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/order/getOrderDetail/${objectId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setInfo(getRes.responsePacket)
      }
    } catch (e) {
      console.log(e, 'error in detail api of cart')
    }
  };

  useEffect(() => {
    detail();
  }, []);


  // Image Magifinify
  const [imgUrl, setImgUrl] = useState();
  const [showImg, setShowImg] = useState(false);
  const maginifyImage = (e) => {
    setShowImg(true);
    setImgUrl(e);
  };

  const navigate = useNavigate();

  const timeFormate = (time) => {
    try {
      // Check if the time is valid
      const date = new Date(time);
      if (isNaN(date)) {
        throw new Error("Invalid date");
      }

      const options = {
        weekday: 'short',  // Thu
        day: 'numeric',    // 5
        month: 'short',    // Dec
        year: 'numeric',   // 2024
        hour: '2-digit',   // 10
        minute: '2-digit'  // 14
      };

      const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
      return formattedDate;
    } catch (error) {
      console.error("Invalid time value:", error);
      return "Invalid Date";
    }
  };

  return (
    <>
      <div className="category">
        <div className="row">
          <div className="category" style={{ display: "block", }}>
            <div className="category-nav" >
              <div className="category-text">
                <h4>Order Detail</h4>
              </div>
              <div className="category-btn">
                <button className='btn' onClick={() => navigate(-1)}><RxCross1 /></button>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>

      <div className="order-detail">
        <div className="order-detail-flex">

          <div className="ordered-item-container">
            <div className="card-b">
              <h3 className="card-title">Ordered Item Details</h3>
              <table className="item-table">
                <thead>
                  <tr>
                    <th>Sr #</th>
                    <th>Title</th>
                    <th>MRP</th>
                    <th>Selling Price</th>
                    <th>Qty.</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>

                  {info?.itemDetailList?.map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        <div className="img" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <img src={item?.itemImageUrls?.[0]} alt="img" style={{ width: "100%", height: "100px", }} onClick={() => maginifyImage(item?.itemImageUrls?.[0])} loading="lazy" />
                        </div>

                      </td>
                      <td>
                        {item.title} <span className="info-icon"></span>
                      </td>
                      <td>{item.mrp}</td>
                      <td>{item.sellingPrice}</td>
                      <td>{item.quantity}</td>
                      <td>{item.sellingPrice * item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Order Summary */}
              <div className="summary">
                <div className="summary-row">
                  <span>Item Total</span>
                  <span>{info?.subTotal}</span>
                </div>
                <div className="summary-row">
                  <span>Coupon Discount</span>
                  <span className="negative">{info?.couponDiscountAmount}</span>
                </div>
                <div className="summary-row">
                  <span>Delivery Charges</span>
                  <div>
                    <div>{info?.deliveryCharges}</div>
                  </div>
                </div>
                <div className="summary-row">
                  <span>Packing Charges</span>
                  <div>
                    <div>{info?.packingCharges}</div>
                  </div>
                </div>
                <div className="summary-row total">
                  <span>Order Total</span>
                  <span>{info?.orderTotal}</span>
                </div>
              </div>
            </div>
          </div>
           {/* Customer Detail */}
           <div className="card" style={{marginLeft:"15px", maxHeight:"420px"}}>
            <h3 className="card-title">Customer Detail</h3>
            <div className="row">
              <span className="label">Full Name:-  </span>
              <span className="value">{info?.customerAddressDetail?.firstName} {info?.customerAddressDetail?.lastName}</span>
            </div>
            <div className="row">
              <span className="label">Address:-  </span>
              <span className="value">{info?.customerAddressDetail?.addressLine1}, {info?.customerAddressDetail?.landMark}</span>
            </div>
            <div className="row">
              <span className="label">City:-  </span>
              <span className="value">{info?.customerAddressDetail?.cityTitle}</span>
            </div>
            <div className="row">
              <span className="label">PinCode:-  </span>
              <span className="value">{info?.customerAddressDetail?.pinCode}</span>
            </div>
            <div className="row">
              <span className="label">State:-  </span>
              <span className="value">{info?.customerAddressDetail?.stateTitle}</span>
            </div>
            <div className="row">
              <span className="label">Mobile Number:-  </span>
              <span className="value"> {info?.customerDetail?.userCustomerMobile}</span>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card">
            <h3 className="card-title">Book Store Detail</h3>
            <div className="row">
              <span className="label">Title:-  </span>
              <span className="value">The Books24</span>
            </div>
          </div>

          {/* Order Detail */}
          <div className="card" >
            <h3 className="card-title">Order Detail</h3>
            <div className="row">
              <span className="label">Order Reference #:-  </span>
              <span className="value">{info?.orderId}</span>
            </div>
            <div className="row">
              <span className="label">Order Date Time:-  </span>
              <span className="value">{
                info?.orderStatus === "ORDER" ? timeFormate(info?.createdAt) : timeFormate(info?.orderAt)
              }</span>
            </div>
            <div className="row">
              <span className="label">Payment Type:-  </span>
              <span className="value">{info?.paymentType}</span>
            </div>
            <div className="row">
              <span className="label">Payment Status:-  </span>
              <span className="value">{info?.paymentStatus}</span>
            </div>
            <div className="row">
              <span className="label">Order Total:-  </span>
              <span className="value">{info?.orderTotal}</span>
            </div>

          </div>

          {/* Ordered Status */}
          <div className="card">
            <h3 className="card-title">Ordered Status</h3>
            <table className="table">
              <thead>
                <tr>
                  <th>Sr #</th>
                  <th>Status</th>
                  <th>Recorded At</th>
                </tr>
              </thead>
              <tbody>
                {info?.orderStatusLogList?.map((status, index) => (
                  <tr key={status.id}>
                    <td>{index + 1}</td>
                    <td>{status.orderStatusEnum}</td>
                    <td>{timeFormate(status.modifiedAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

      </div>
      <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />
    </>
  )
}
export default OrderDetail;